import React from 'react'
import { Toaster } from 'react-hot-toast';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import PrivacyPolicy from './routes/PrivacyPolicy/PrivacyPolicy';
import Terms from './routes/Terms/Terms';
import DeleteAccount from './routes/DeleteAccount/DeleteAccount';
import Support from './routes/Support/Support';

export default function App() {
  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Toaster />
        <BrowserRouter>
          <Routes>
            <Route path='/privacy' element={<PrivacyPolicy />} />
            <Route path='/terms' element={<Terms />} />
            <Route path='/delete' element={<DeleteAccount />} />
            <Route path='/support' element={<Support />} />
          </Routes>
        </BrowserRouter>
      </LocalizationProvider>
    </>
  )
}